class OfferItem {
  constructor(json) {
    this.json = json;
    this.listing = json.listing;
    this.price = json.listing.price.amount;
    this.shippingPrice = json.listing.shipping.initial_offer_rate.rate.original.amount;
    this.currency = json.listing.listing_currency;
    this.listingId = json.listing.id;
  }
}

module.exports = OfferItem;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/email_offers/offer_item.js